import { Interfaces, AppConstants } from "@/core/Export";
import cuid from "cuid";

export namespace Models {
  export class TFile {
    constructor() {}
    key: number;
    fileType: string = null;
    file: any = null;

    get hasFileTypeError() {
      return !this.fileType;
    }
    get hasFileError() {
      return !this.file;
    }
    get hasFileMaxUploadSize() {
      return this.file && this.file.size > AppConstants.MaxUploadSize;
    }
  }

  export class TResidentIdentification {
    idNo: string = "";
    dob: any = "";
    year: number;
  }

  export class TRequestForm {
    firstName;
    lastName;
    fatherName;
    dob;
    idNo;
    city;
    address;
    phoneNo;
    residentFromDate;
    email;
    workplaceName;
    workplaceAddress;
    workPlacePhoneNo;
    martialStatus;
    noOfChildsUpTo18;
    partnerLastName;
    partnerFirstName;
    partnerFatherName;
    partnerDob;
    partnerIdNo;
    partnerAddress;
    partnerPhoneNo;
    partnerWorkPlaceAddress;
    partnerWorkPlacePhoneNo;
    partnerWorkPlaceName;
    children: Array<TChildren>;
    hmo;
    hmoBranch;
    authorityName;
    fillFormDate;
    signature;
    id;
    year;
  }

  export class TChildren {
    id: number = 0;
    firstName: string = "";
    idNo: string = "";
    dob: string = "";
    educationInstName: string = "";
    city: string = "";
  }

  export class uiHeader {
    caption: string = "";
    icon: string = "";
    class: string = "";
    visible = true;
  }

  export class onPropertyChangeOptions {
    entityName: string = "";
    layoutCode: string = "";
    id: string = null;
    fieldName: string = "";
    newValue: any;
    formData: any;
  }

  export class formsLayouts {
    private _inner: Array<any>;

    constructor() {
      this._inner = new Array<any>();
    }

    public loadLayout(entityName: string) {
      let layout = this._inner.find(s => s.Id == entityName);
    }
  }

  export class TBaseItem {
    id = 0;
    code = "";
    name = "";
  }

  export class BaseDto {
    Id: string = cuid();
    code: string = null;
    isDraft: boolean = false;
  }

  export class SelectableItem {
    constructor(source?) {
      AppUtils.copyFromTo(this, source);
    }
    id: number;
    display: string;
    tag: object;
  }

  export class AppUtils {
    static formatTime(value: string) {
      if (!value) return "";
      let hours = 0;
      let minutes = 0;
      value = value.replace(":", "");

      if (value.length == 1) {
        hours = parseInt(value);
      } else if (value.length == 2) {
        let test = parseInt(value);
        if (test < 24) {
          hours = test;
        }
      } else if (value.length == 3) {
        var str = value.slice(0, 1);
        hours = parseInt(str);
        str = value.slice(1, 3);
        minutes = parseInt(str);
      } else if (value.length == 4) {
        var str = value.slice(0, 2);
        hours = parseInt(str);
        str = value.slice(2, 4);
        minutes = parseInt(str);
      }

      if (hours === 0 && minutes === 0) return "";
      if (minutes > 60) minutes = 0;
      if (hours >= 24) hours = 0;
      let strH = this.formatTimePart(hours);
      let strM = this.formatTimePart(minutes);

      return strH + ":" + strM;
    }

    static formatTimePart(value: number) {
      return value > 9 ? value.toString() : "0" + value.toString();
    }

    static getMinutes(value: string) {
      let time = new Models.time(value);
      return time.toMinutes;
    }

    static copyFromTo(target, source) {
      Object.assign(target, source);
    }
  }

  export class time {
    private _hours: number;
    private _minutes: number;

    constructor(value: string) {
      if (value) {
        let h = value.slice(0, 2);
        let m = value.slice(3, 5);
        this._hours = parseInt(h);
        this._minutes = parseInt(m);
      } else {
        this._hours = 0;
        this._minutes = 0;
      }
    }

    public get hours() {
      return this._hours;
    }
    public get minutes() {
      return this._minutes;
    }

    public get toMinutes() {
      return this.hours * 60 + this.minutes;
    }

    fromMinutes(from: number) {
      this._hours = Math.floor(from / 60);
      this._minutes = from - this._hours * 60;
    }
  }
}
